import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const createAccount = createAsyncThunk(
    'createAccountForm/createAccount',
    async ({newAccount, token}) => {
        const requestBody = JSON.stringify(newAccount);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/accounts/create`,
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: requestBody
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const createAccountFormSlice = createSlice({
    name: 'createAccountForm',
    initialState: {
        branchId: 'blank',
        userId: 'blank',
        accountType: 'CHECKING',
        active: false,
        confirmingCreateAccount: false,
        creatingNewAccount: false,
        failedToCreateNewAccount: false,
        status: '',
        createdAccount: {}
    },
    reducers: {
        changeNewAccountBranchId: (state, action) => {
            return {
                ...state,
                branchId: action.payload,
                status: ''
            }
        },
        changeNewAccountUserId: (state, action) => {
            return {
                ...state,
                userId: action.payload,
                status: ''
            }
        },
        changeNewAccountType: (state, action) => {
            return {
                ...state,
                accountType: action.payload,
                status: ''
            }
        },
        toggleCreateAccountForm: (state) => {
            return {
                ...state,
                active: !state.active,
                status: ''
            }
        },
        changeCreateAccountFormStatus: (state, action) => {
            return {
                ...state,
                status: action.payload
            }
        },
        clearCreateAccountForm: (state) => {
            return {
                ...state,
                accountId: '',
                branchId: '',
                userId: '',
                accountType: 'CHECKING'
            }
        },
        setConfirmingCreateAccount: (state, action) => {
            return {
                ...state,
                confirmingCreateAccount: action.payload
            }
        }
    },
    extraReducers: {
        [createAccount.pending]: (state) => {
            return {
                ...state,
                creatingNewAccount: true,
                failedToCreateNewAccount: false
            }
        },
        [createAccount.fulfilled]: (state, action) => {
            return {
                ...state,
                creatingNewAccount: false,
                failedToCreateNewAccount: false,
                status: action.payload.id ? "Account successfully created" : "Failed to create account",
                createdAccount: action.payload
            }
        },
        [createAccount.rejected]: (state) => {
            return {
                ...state,
                creatingNewAccount: false,
                failedToCreateNewAccount: true
            }
        }
    }
})

export const selectCreateAccountFormBranchId = (state) => state.createAccountForm.branchId;
export const selectCreateAccountFormUserId = (state) => state.createAccountForm.userId;
export const selectCreateAccountFormAccountType = (state) => state.createAccountForm.accountType;
export const createAccountFormIsActive = (state) => state.createAccountForm.active;
export const createAccountStatus = (state) => state.createAccountForm.status;
export const selectConfirmingCreateAccount = (state) => state.createAccountForm.confirmingCreateAccount;
export const creatingAccount = (state) => state.createAccountForm.creatingNewAccount;
export const selectCreatedAccount = (state) => state.createAccountForm.createdAccount;

export const { changeNewAccountId, changeNewAccountBranchId, changeNewAccountUserId, changeNewAccountType, toggleCreateAccountForm, changeCreateAccountFormStatus, clearCreateAccountForm, setConfirmingCreateAccount } = createAccountFormSlice.actions;

export default createAccountFormSlice.reducer;